import * as React from "react";
const SvgMenu = (props) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { y: 8, width: 32, height: 2 }), /* @__PURE__ */ React.createElement("rect", { y: 22, width: 32, height: 2 }));
export default SvgMenu;
